import { getCollapsiblePanelStyles } from './collapsible-panel';

export const getNativeAdsStyles = (components, theme) => ({
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
});
